export const environment = {
  REACT_APP_Identity_Microservice_URL: "https://api.wajeez.com/api/",
  REACT_APP_Content_Microservice_URL: "https://api.wajeez.com/api/",
  REACT_APP_Payment_Microservice_URL: "https://api.wajeez.com/api/",
  REACT_APP_Engagement_Microservice_URL: "https://api.wajeez.com/api/",
  REACT_APP_Media_Microservice_URL: "https://api.wajeez.com/api/",

  REACT_APP_Wajeez_Web_Url: "https://auth.wajeez.com",
};
